import React, { ReactElement } from 'react';
import { FlexProps } from 'components/flex/types';
import { LiveMeetingAttendanceConfirmationStatusEnum, LiveVideoCard } from 'app/types/cards/LiveVideoCard';
import { useLives } from 'features/lives';
import { LiveCard } from 'components';

interface LivesCardProps extends FlexProps {
  live: LiveVideoCard;
  productClassUuid: string;
  enrolled: boolean;
  boxSmall?: boolean;
  hideButton?: boolean;
}

const LivesCard = ({ live, boxSmall = false, productClassUuid, enrolled, hideButton = false, ...props }: LivesCardProps): ReactElement => {
  const { sanitizeCardToLiveCard } = useLives();

  const liveVideo = sanitizeCardToLiveCard(live);

  if (!liveVideo) return <></>;

  return <LiveCard {...liveVideo} theme="light" productEnrolled={enrolled} hat={undefined} boxSmall={boxSmall} hideButton={hideButton} />;
};

export default LivesCard;
